import axios from 'axios'
import {ResponseCRUD, ResponseObject, ResponseObjectPaginated} from '../model'
import {ID} from '../../../../../_metronic/helpers'
import {
  CreateParameterDto,
  GetParameterFilter,
  ParameterCostModelDocument,
  ParameterModelDocument,
  ParameterRange,
  UpdateCostDto,
  UpdateParameterDto,
} from '../model/parameter.model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

export function getParametersService(dto: GetParameterFilter) {
  return axios.post<ResponseObjectPaginated<ParameterModelDocument[]>>(
    `${BASEURL}/billingParameters/getListParameters`,
    dto,
  )
}

export async function createParameterService(dto: CreateParameterDto | UpdateParameterDto) {
  return await axios.post<ResponseObject<ParameterModelDocument>>(
    `${BASEURL}/billingParameters/createParameter`,
    dto,
  )
}

export async function getParameterByIdService(paramId: ID) {
  return await axios.get<ResponseObject<ParameterModelDocument>>(
    `${BASEURL}/billingParameters/getInformationById?ParamFacturacionCabId=${paramId}`,
  )
}

export async function updateParameterService(dto: UpdateParameterDto) {
  return await axios.post<ResponseObject<ParameterModelDocument>>(
    `${BASEURL}/billingParameters/updateParameter`,
    dto,
  )
}

export async function recalculateCostsService(id: any) {
  return await axios.post<ResponseCRUD>(
    `${BASEURL}/billingParameters/recalculateCost?ParamFacturacionCabId=${id}`,
  )
}

export async function completeStaysService(id: any) {
  return await axios.post<ResponseCRUD>(
    `${BASEURL}/billingParameters/completeStays?ParamFacturacionCabId=${id}`,
  )
}

export async function deleteParameterService(id: string | undefined) {
  return await axios.delete<ResponseObject<ParameterModelDocument>>(
    `${BASEURL}/billingParameters/deleteParameter?ParamFacturacionCabId=${id}`,
  )
}

// NOTES

export function getListCostService(paramFacturacionCabId: ID) {
  return axios.post<ResponseObjectPaginated<ParameterCostModelDocument[]>>(
    `${BASEURL}/billingParameters/getListCosts?ParamFacturacionCabId=${paramFacturacionCabId}`,
  )
}

export async function updateCostsService(dto: UpdateCostDto) {
  const {ParamFacturacionCabId, TipoHabitacionId, Costo, RangoCodigo, TipoRopaId, TipoServicioComensalId,TipoServicioComensalRefId} = dto
  return await axios.post<ResponseObject<ParameterCostModelDocument>>(
    `${BASEURL}/billingParameters/updateCosts`,
    {
      ParamFacturacionCabId: ParamFacturacionCabId,
      TipoHabitacionId: TipoHabitacionId,
      RangoCodigo: RangoCodigo,
      Costo: Costo,
      TipoRopaId: TipoRopaId,
      TipoServicioComensalId:TipoServicioComensalId,
      TipoServicioComensalRefId:TipoServicioComensalRefId
    },
  )
}

export function getListRangesService(aplicacionId: ID, rangoCabId: ID) {
  return axios.post<ResponseObject<ParameterRange[]>>(
    `${BASEURL}/billingParameters/getListRanges?AplicacionId=${aplicacionId}&RangoCabId=${rangoCabId}`,
  )
}

export function getListTypesService(data: any) {
  return axios.post<ResponseObject<ParameterRange[]>>(
    `${BASEURL}/billingParameters/getListTypeService`,
    data,
  )
}
